module.exports = __webpack_public_path__ + "static/img/shoonya-logo-with-tagline.2739e40.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/shoonya-logo-with-tagline.svg
// module id = hcc1
// module chunks = 74